import { mixpanel } from '@fiverr-private/obs';

export const sendMixpanelWidgetImpressionEvent = (properties) => {
    const { affiliateId, hostReference } = properties;

    mixpanel.track('GigAds - Widget - Impression', {
        'Affiliate Id': affiliateId,
        'Host Reference': hostReference,
    });
};

export const sendMixpanelWidgetClickEvent = (properties) => {
    const { affiliateId, hostReference, clickName, clickSection } = properties;

    mixpanel.track('GigAds - Widget - Click', {
        'Affiliate Id': affiliateId,
        'Host Reference': hostReference,
        'Click Name': clickName,
        'Click Section': clickSection,
    });
};
